import { MODULE } from "@/config/modules";
import { IModuleExtraDossiersMetaData, IModuleExtraUsersMetaData } from "@/utils/module-meta-datas";
import { Tier } from "@/utils/tier";
import { Module } from "./module";
import { PlanModule } from "./plan-module";

export enum PaymentFrequency {
	Quarter = 0,
	Yearly = 1,
	Permanent = 2,
	Monthly = 3
}



export class Plan {
	tier:Tier = Tier.Starter;
	paymentFrequency:PaymentFrequency = PaymentFrequency.Permanent;
	modules:PlanModule[] = [];
	dontAddDefaultModules:boolean = false;
	get maxUsers():number{
		for (let mod of this.modules){
			if (mod.ModuleID == MODULE.EXTRA_USERS){
				let metaData = mod.MetaData as IModuleExtraUsersMetaData;
				return parseInt(metaData["extra-users"] || "0") + 1;
			}
		}
		return 1;
	}
	get maxDossiers():number{
		for (let mod of this.modules){
			if (mod.ModuleID == MODULE.EXTRA_DOSSIERS){
				let metaData = mod.MetaData as IModuleExtraDossiersMetaData;
				return parseInt(metaData["extra-dossiers"] || "0") + 1;
			}
		}
		return 1;
	};


	public constructor(data:any){
		this.tier = data.tier;
		this.paymentFrequency = data.paymentFrequency;
		this.modules = (data.modules || []).map((m:any)=>new PlanModule(m));
		this.dontAddDefaultModules = data.dontAddDefaultModules || false;
	}

	public getJson():any{
		return {
			tier: this.tier,
			paymentFrequency: this.paymentFrequency,
			modules: this.modules.map(m=>m.getJSON()),
			dontAddDefaultModules: this.dontAddDefaultModules
		};
	}

	tierName():string{
		if (this.tier == Tier.Starter) {
			return "STARTER";
		}else if (this.tier == Tier.Pro){
			return "PROFESSIONAL";
		}else if (this.tier == Tier.Enterprise){
			return "ENTERPRISE";
		}
		return "INVALID PLAN";
	}

	paymentFrequencyName():string{
		if (this.paymentFrequency == PaymentFrequency.Quarter){
			return "QUARTER";
		} else if (this.paymentFrequency == PaymentFrequency.Yearly){
			return "YEARLY";
		} else if (this.paymentFrequency == PaymentFrequency.Permanent){
			return "PERMANENT";
		} else if (this.paymentFrequency == PaymentFrequency.Monthly){
			return "MONTHLY";
		}
		return "ERROR";
	}

	getModules(allModules:Module[]):Module[] {
		return allModules.filter(m=>this.modules.findIndex(thisMod=>thisMod.ModuleID == m.id) != -1);
	}

	addModule(m:Module | number, metaData?:any){
		let moduleId:number = m as number;
		if (typeof(m) == "object") {
			moduleId = m.id;
		}
		for (let availableModule of this.modules) {
			if (availableModule.ModuleID == moduleId) {
				availableModule.MetaData = metaData;
				return;
			}
		}
		let planModule = new PlanModule();
		planModule.ModuleID = moduleId;
		planModule.MetaData = metaData;
		this.modules.push(planModule);
	}

	removeModule(m:Module | number){
		let moduleId = m as number;
		if (typeof(m) == "object") {
			moduleId = m.id;
		}
		for (let i = this.modules.length -1; i >= 0; i--){
			if (this.modules[i].ModuleID == moduleId){
				this.modules.splice(i,1);
			}
		}
	}
}